import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceCheckoutShippingLabel = Atom.createRender((props) => {
  const {attributes, data, classes, generateAttributes, renderChild} = props;

  return (
    // TODO: fix jsx-a11y lint error
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </label>
  );
});

const config = createIntegratedAtom({
  displayName: 'Shipping Method',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [
      {is: 'CommerceCheckoutShippingMethodRadioButton', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          paddingTop: px(16),
          paddingBottom: px(16),
          paddingRight: px(16),
          paddingLeft: px(16),
          fontWeight: 400,
          display: 'flex',
          flexDirection: 'row',
          borderBottomColor: createRgbaColor('e6e6e6'),
          borderBottomWidth: px(1),
          borderBottomStyle: 'solid',
          marginBottom: px(0),
          backgroundColor: createRgbaColor('fff'),
          alignItems: 'baseline',
        },
      },
    },
  },
  render: CommerceCheckoutShippingLabel,
  fields: {children: TListOfElement},
});

export default config;
